import { makeAutoObservable } from "mobx"
import InsightUpload from "./InsightUpload"

export default class ActionInsight {
  constructor(actionInsight = {}) {
    this.id = actionInsight.id
    this.action_type = actionInsight.action_type
    this.reach = actionInsight.reach || 0
    this.impressions = actionInsight.impressions || 0
    this.clicks = actionInsight.clicks || 0
    this.likes = actionInsight.likes || 0
    this.comments = actionInsight.comments || 0
    this.saves = actionInsight.saves || 0
    this.plays = actionInsight.plays || 0
    this.shares = actionInsight.shares || 0
    this.reposts = actionInsight.reposts || 0
    this.reel_duration = actionInsight.reel_duration || 0
    this.watchtime = actionInsight.watchtime || 0
    this.watchtime_percentage = actionInsight.watchtime_percentage || 0
    this.story_sequence_count = actionInsight.story_sequence_count || 0
    this.story_first_sequence_reach = actionInsight.story_first_sequence_reach || 0
    this.story_last_sequence_reach = actionInsight.story_last_sequence_reach || 0
    this.story_first_sequence_impressions = actionInsight.story_first_sequence_impressions || 0
    this.story_last_sequence_impressions = actionInsight.story_last_sequence_impressions || 0
    this.sticker_taps = actionInsight.sticker_taps || 0
    this.amount_likes = actionInsight.amount_likes || 0
    this.amount_comments = actionInsight.amount_comments || 0
    this.views = actionInsight.views || 0
    this.in_country_views_percentage = actionInsight.in_country_views_percentage || 0
    this.female_views_percentage = actionInsight.female_views_percentage || 0
    this.male_views_percentage = actionInsight.male_views_percentage || 0
    this.action_id = actionInsight.action_id
    this.insight_uploads = actionInsight.insight_uploads?.map(upload => new InsightUpload(upload)) || []

    makeAutoObservable(this)
  }
}